import axios from 'axios';

axios.defaults.baseURL = '/api/';
axios.defaults.withCredentials = true;
